<form name="latestUpdateForm" [formGroup]="latestUpdateForm" novalidate>

    <header-bar headingClass="fa-calendar-o" [pageTitle]="title"></header-bar>
    <div class="container mt-5">
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-header bg-primary text-white">
                        <div class="row align-items-center">
                            <p class="h3 m-0 col">Update details</p>
                            <div class="col text-right">
                                <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium"
                                    [disabled]="!latestUpdateForm.valid"
                                    (click)="saveLatestUpdate(latestUpdateForm.value)">
                                    <span *ngIf="!latestUpdate?.id">Publish update</span>
                                    <span *ngIf="latestUpdate?.id">Save changes</span>
                                    <i class="fa fa-check ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <p class="textBody--xs u-marginBottom--medium">Please complete all fields marked with an
                                    asterix (*)</p>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="title">Location</label>
                                            <input name="countryId" class="form-control" formControlName="countryId"
                                                *ngIf="false" />
                                            <ng-select id="countrySelector" [allowClear]="true"
                                                *ngIf="latestUpdate?.id == null" [items]="countries"
                                                placeholder="Select a location (Optional)"
                                                (selected)="countrySelected($event)" (removed)="countryRemoved()">
                                            </ng-select>
                                            <p>
                                                <span
                                                    *ngIf="latestUpdate?.countryName"><strong>{{latestUpdate?.countryName}}</strong></span>
                                                <span *ngIf="!latestUpdate?.countryName && latestUpdate?.id"><strong>No
                                                        location specified</strong></span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row"
                                    [ngClass]="{ 'has-error' : !latestUpdateForm.controls['url'].valid && latestUpdateForm.controls['url'].touched }"
                                    *ngIf="latestUpdateForm.controls['countryId'] != undefined">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="title">Supporting documentation link</label>
                                            <div *ngIf="latestUpdate?.id == null">
                                                <p class="textBody--xs">You may include a link to supporting
                                                    documentation below.</p>
                                                <input type="text" class="form-control" formControlName="url"
                                                    name="url" />
                                                <div *ngIf="latestUpdateForm.controls['url'].invalid && latestUpdateForm.controls['url'].touched"
                                                    class="alert alert-danger">Invalid URL format.</div>
                                            </div>
                                            <p>
                                                <span
                                                    *ngIf="latestUpdate?.url"><strong>{{latestUpdate?.url}}</strong></span>
                                                <span *ngIf="!latestUpdate?.url  && latestUpdate?.id"><strong>No url
                                                        specified.</strong></span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row"
                                    [ngClass]="{ 'has-error' : !latestUpdateForm.controls['description'].valid && latestUpdateForm.controls['description'].touched }">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for="title">Latest update description *</label>
                                            <ckeditor [editor]="Editor" 
                                                      [config]="config" 
                                                      formControlName="description"
                                                      [ckEditorEnhanced]="Editor">
                                            </ckeditor>
                                            <div *ngIf="latestUpdateForm.controls['description'].hasError('required') && latestUpdateForm.controls['description'].touched"
                                                class="alert alert-danger">Content to publish is required.</div>
                                            <div *ngIf="latestUpdateForm.controls['description'].hasError('trimmedminlength') && latestUpdateForm.controls['description'].touched"
                                                class="alert alert-danger">Content to publish needs to be at least 3
                                                characters.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <label for="deleted">Disable update</label>
                                        <p class="textBody--xs">
                                            <input type="checkbox" name="disabled" formControlName="disabled"
                                                class="u-marginTop--small " />
                                            Hide this update from users
                                        </p>
                                    </div>
                                </div>
                                <div class="row" *ngIf="emailFeatureEnabled">
                                    <div class="col">
                                        <label for="emailalert">Email alert to client users?</label>
                                        <p class="textBody--xs">
                                            <input class="u-marginTop--small ng-untouched ng-pristine ng-valid"
                                                formControlName="sendEmail" name="emailalert" type="checkbox">
                                            Warning - this will send an email to all client users containing the text
                                            above
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<confirmationmodal #confirmModal (onAccept)="onAccept();"></confirmationmodal>